<template>
  <b-modal id="modal-mensagem" ok-only title="Atenção!">
    <p class="my-4">{{ mensagem }}</p>
  </b-modal>
</template>
<script>
export default {
  name: "Modal",
  data() {
    return {
      mensagem: "",
    };
  },

  mounted() {
    this.$root.$on("acionarModal", (data) => {
      this.$bvModal.show("modal-mensagem");
      this.mensagem = data;
    });
  },
};
</script>

<style>
.close {
  display: none;
}
</style>